import { Component } from '@angular/core';
import { LoaderService } from '../../shared/services/loader.service';
import { LoaderParams } from '../../shared/loader-params';

@Component({
  selector   : 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls  : ['./loader.component.scss']
})
export class LoaderComponent {

  params: LoaderParams = { loading: false, small: true };

  constructor(private loaderService: LoaderService) {
    loaderService.getObservable().subscribe(p => {
      this.params = p;
    });
  }
}
